var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1785_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49978 10.2057H4.50008C5.55682 10.2057 6.41675 9.34581 6.41675 8.28907C6.41675 7.23233 5.55682 6.37241 4.50008 6.37241C3.44334 6.37241 2.58341 7.23233 2.58341 8.28907L2.58341 8.28937C2.58402 8.79744 2.78612 9.28452 3.14538 9.64378C3.50463 10.003 3.99172 10.2051 4.49978 10.2057ZM8.08695 7.19532L8.14095 7.37241H8.32608H16.2501V9.20574H15.1667H14.9167V9.45574V11.3724H12.7501V9.45574V9.20574H12.5001H8.32608H8.14095L8.08695 9.38282C7.82481 10.2425 7.26264 10.9794 6.50281 11.4594C5.74297 11.9395 4.83601 12.1306 3.94708 11.9981C3.05815 11.8656 2.24638 11.4182 1.65958 10.7374C1.07279 10.0567 0.75 9.18783 0.75 8.28907C0.75 7.39032 1.07279 6.52146 1.65958 5.8407C2.24638 5.15994 3.05815 4.71257 3.94708 4.58006C4.83601 4.44754 5.74297 4.63869 6.50281 5.1187C7.26264 5.59871 7.82481 6.33565 8.08695 7.19532Z",
    fill: "#CDCDCD",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1785_3627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.289062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ed0e1d990b72ebbbd5d70676921f540b.svg";
export { ForwardRef as ReactComponent };